import React from "react";
import { Row, Col } from "react-bootstrap";
import Page from "../common/page/Page";
import useTranslationAuthenticationUi from "./useTranslationAuthenticationUi";
import useShowLoader from "../common/loading-widgets/useShowLoader";
import ConnectionMode from "./ConnectionMode";

export default function ConnectionModePage() {
  const { t, loading: tLoading } = useTranslationAuthenticationUi();
  useShowLoader(tLoading, "ConnectionMode");
  if (tLoading) return null;

  return (
    <div className="ConnectionModePage">
      <Page>
        <Page.Title
          text={t("authentication-ui:connection_mode")}
          loading={tLoading}
        />
        <Page.Content>
          <Row>
            <Col>
              <ConnectionMode />
            </Col>
          </Row>
        </Page.Content>
      </Page>
    </div>
  );
}
